import './custom_attributes/email_user_profile_attribute_view.js.coffee';# Added by Script
import './custom_attributes/fixed_string_user_profile_attribute_view.js.coffee';# Added by Script
import './custom_attributes/integer_user_profile_attribute_view.js.coffee';# Added by Script
import './custom_attributes/boolean_user_profile_attribute_view.js.coffee';# Added by Script
import './custom_attributes/free_text_user_profile_attribute_view.js.coffee';# Added by Script
import './custom_attributes/date_user_profile_attribute_view.js.coffee';# Added by Script
Customer.Users ||= {}

class Customer.Users.ProfilePreviewCustomAttributesView extends Backbone.View
  template: JST['backbone/templates/customer/users/profile_preview_custom_attributes']
  attributeViewClassNames:
    Date: Customer.DateUserProfileAttributeView
    FreeText: Customer.FreeTextUserProfileAttributeView
    Boolean: Customer.BooleanUserProfileAttributeView
    Integer: Customer.IntegerUserProfileAttributeView
    FixedString: Customer.FixedStringUserProfileAttributeView
    Email: Customer.EmailUserProfileAttributeView

  initialize: ({profileID, attributeCollection}) ->
    @profileID = profileID
    @attributeCollection = attributeCollection
    @listenTo @attributeCollection, 'profile_custom_attributes:change', (response) =>
      @trigger 'profile_custom_attributes:change', response
    @listenTo @attributeCollection, 'profile_custom_attributes:restore', =>
      @trigger 'profile_custom_attributes:restore'

  render: ->
    @$el.html(@template())
    @$el.find('#confirm').on 'click', @saveChanges
    @$el.find('#cancel').on 'click', @revertChanges
    @attributeViews = []
    @attributeCollection.each (attribute) =>
      return if !attribute.get('definition').visible
      UserProfileAttributeView = @getViewFor(attribute.get('definition').attribute_type_name)
      attributeView = new UserProfileAttributeView(attribute: attribute)
      @$el.find('#profile-preview-custom-attributes').append(attributeView.render().el)
      @listenTo attributeView, 'profile_custom_attributes:disable_save', @_disableSaveButton
      @listenTo attributeView, 'profile_custom_attributes:enable_save', @_enableSaveButton
      @listenTo attributeView, 'profile_custom_attributes:modified_field', =>
        @$el.find('#actions').addClass('active')
      @attributeViews.push(attributeView)
    @

  _disableSaveButton: ->
    @$el.find('#confirm').attr('disabled', true)

  _enableSaveButton: ->
    @$el.find('#confirm').attr('disabled', false)


  isBeingModified: ->
    @$el.find('#actions').hasClass('active')

  afterRender: =>
    _.each(@attributeViews, (attribute) =>
      attribute.afterRender()
    )

  getViewFor: (attributeTypeName) ->
    @attributeViewClassNames[attributeTypeName] || @attributeViewClassNames['FreeText']

  saveChanges: =>
    @_keepCustomerSessionAlive()
    _.each(@attributeViews, (attributeView) =>
      attributeView.disableFurtherChange()
      attributeView.cleanErrors()
    )
    @$el.find('.customer-button').addClass('disabled')
    added = []
    deleted = []
    for view in @attributeViews
      added.push view.getAdded()
      deleted.push view.getDeleted()
    @attributeCollection.saveChanges
      profileID: @profileID
      added: added
      deleted: deleted

  revertChanges: =>
    @_keepCustomerSessionAlive()
    @trigger 'profile_custom_attributes:restore'
    @$el.find('#actions').removeClass('active')

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  onAttributesValidationError: (userProfileAttributeErrors) =>
    @attributeViews.filter(
      (attributeView) -> userProfileAttributeErrors.hasOwnProperty(attributeView.model.get('definition').code)
    ).forEach((attributeView) -> attributeView.$el.addClass('validation-error'))

  onTicketClose: =>
    @attributeViews.forEach((attributeView) -> attributeView.$el.removeClass('validation-error'))
